<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SubmitBar',
})
</script>
<template>
  <Affix :offset-bottom="16">
    <div :class="bem({ bordered })">
      <slot name="prefix" />
      <slot>
        <Button v-if="cancelVisible" v-bind="cancelAttrs" @click="$emit('cancel')">取消</Button>
        <Button type="primary" v-bind="submitAttrs" @click="$emit('submit')">{{ submitText }}</Button>
      </slot>
    </div>
  </Affix>
</template>

<script lang="ts" setup name="SubmitBar">
import { Affix, Button } from 'ant-design-vue'
import { createNamespace } from '@bd/vue3-utils'
import type { ButtonProps } from 'ant-design-vue/es/button'
const [_, bem] = createNamespace('SubmitBar')
withDefaults(
  defineProps<{
    cancelAttrs?: ButtonProps
    cancelVisible?: boolean
    submitAttrs?: ButtonProps
    submitText?: string
    bordered?: boolean
  }>(),
  {
    cancelVisible: false,
    submitText: '保存',
    bordered: true
  }
)
defineEmits<{
  (event: 'submit'): void
  (event: 'cancel'): void
}>()
</script>

<style lang="less">
.ant-affix {
  .submit-bar {
    box-shadow: @box-shadow-base;
  }
}

.submit-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: @padding-sm @padding-md;
  border-radius: @border-radius-large;
  background: @white;

  &--bordered {
    border-top: @border-base;
  }

  & > *:not(:last-child) {
    margin-right: @margin-md;
  }
}
</style>
